// components/Layout.js
import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import NotificationModal from './NotificationModal';
import { useAuth } from '../contexts/AuthContext';
import notificationService from '../services/notificationService';

/**
 * Компонент общего макета приложения
 * @param {Object} props - Свойства компонента
 * @param {React.ReactNode} props.children - Дочерние компоненты
 * @returns {JSX.Element} - Компонент для рендеринга
 */
const Layout = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0);
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);

  // Загрузка уведомлений при авторизации пользователя
  useEffect(() => {
    const loadNotifications = async () => {
      if (!isAuthenticated || !user) {
        return;
      }

      setIsLoadingNotifications(true);
      try {
        const unreadNotifications = await notificationService.getUnreadNotifications();
        if (unreadNotifications && unreadNotifications.length > 0) {
          setNotifications(unreadNotifications);
          setCurrentNotificationIndex(0);
        }
      } catch (error) {
        console.error('Ошибка при загрузке уведомлений:', error);
      } finally {
        setIsLoadingNotifications(false);
      }
    };

    loadNotifications();
  }, [isAuthenticated, user]);

  // Обработчик закрытия текущего уведомления
  const handleCloseNotification = () => {
    if (currentNotificationIndex < notifications.length - 1) {
      // Показываем следующее уведомление
      setCurrentNotificationIndex(currentNotificationIndex + 1);
    } else {
      // Все уведомления показаны, очищаем список
      setNotifications([]);
      setCurrentNotificationIndex(0);
    }
  };

  const currentNotification = notifications.length > 0 ? notifications[currentNotificationIndex] : null;

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1">
        <main className="p-2 lg:p-4 fade-in">
          {children}
        </main>
      </div>
      {/* Модальное окно уведомлений */}
      {currentNotification && !isLoadingNotifications && (
        <NotificationModal
          notification={currentNotification}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default Layout;